<template>
<div class="back" @click="handleBack">
  <SvgIcon icon-class="back" />
</div>
</template>

<script>
import { types, postMessage } from '@hll/cashier-kit'
export default {
  name: 'Back',
  methods: {
    handleBack () {
      postMessage({ action: 'processing', status: 2 })
      this.$store.commit(types.SET_COMPONENT_STATUS, { component: 'PaymentSelectList' })
    }
  }
}
</script>

<style scoped>
.back{
  width: 24px;
  height: 24px;
  position: fixed;
  top:8px;
  left: 8px;
}
</style>
